import { useEffect } from "react";
import { useSearchParams } from "@/lib/router";
import useCountdown from "@/hooks/useCountdown";

const useLoadTimeCountdown = () => {
  const [searchParams] = useSearchParams();
  const loadTime = searchParams.get("load-time");

  const { timeRemaining, startCountdown } = useCountdown(
    Number(loadTime),
    true,
  );

  useEffect(() => {
    if (loadTime) {
      startCountdown();
    }
  }, [loadTime]);

  return { timeRemaining };
};

export default useLoadTimeCountdown;
